export const isIssueSnoozed = (
  snoozedUntilTime: string | null | undefined,
): boolean =>
  snoozedUntilTime !== null &&
  snoozedUntilTime !== undefined &&
  new Date(snoozedUntilTime).getTime() > Date.now();
